﻿export async function getJson(url, options = {}) {
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        },
        ...options
    });

    if (!response.ok) {
        throw new Error(`GET ${url} failed with ${response.status}`);
    }

    return await response.json();
}

export async function postHtml(url, data = {}) {
    const formData = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
    });

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        body: formData.toString()
    });

    if (!response.ok) {
        throw new Error(`POST ${url} failed with ${response.status}`);
    }

    return await response.text();
}